import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=e3cd796c&scoped=true&"
import script from "./group-list.vue?vue&type=script&lang=js&"
export * from "./group-list.vue?vue&type=script&lang=js&"
import style0 from "./group-list.vue?vue&type=style&index=0&id=e3cd796c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cd796c",
  null
  
)

export default component.exports